import {
  CustomerServiceOutlined,
  InfoCircleOutlined,
  LogoutOutlined,
  QuestionOutlined,
  SettingFilled,
  SettingOutlined,
} from '@ant-design/icons';
import { useAuth } from 'auth/AuthContext';
import BackButton from 'components/buttons/BackButton';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import useIsSmallScreen from 'hooks/useIsSmallScreen';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../services/RouteService';

export type ChatsHeaderProps = {
  title: React.ReactNode;
  backButton?: boolean;
  onBackButtonClicked?: () => void;
  style?: React.CSSProperties;
};

const PageTopBar: React.FC<ChatsHeaderProps> = ({
  title,
  backButton = false,
  onBackButtonClicked = undefined,
  style,
}) => {
  // Hooks
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { isSmallScreen } = useIsSmallScreen();
  const { t } = useTranslation();

  const openRoute = (route: string) => {
    navigate(route);
  };

  return (
    <div className="flex w-full shrink-0 items-center justify-between gap-3 bg-background px-4 pt-3 pb-3" style={style}>
      {backButton && (
        <div className="flex items-center">
          <BackButton
            onClick={() => {
              if (onBackButtonClicked) {
                onBackButtonClicked();
              }
            }}
          />
        </div>
      )}
      <h2 className="min-w-0 grow text-foreground">{title}</h2>
      {!backButton && isSmallScreen && (
        <DropdownMenu>
          {/*
           * The antd icon itself is the trigger, so it keeps rendering
           * `role="img" aria-label="setting"` (the suite opens the menu with
           * `get_by_label("setting")`).
           */}
          <DropdownMenuTrigger asChild>
            <SettingFilled tabIndex={0} className="cursor-pointer text-2xl text-foreground" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onSelect={() => openRoute(routes.settings.route)}>
              <SettingOutlined /> {t('menu.settings')}
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={() => openRoute(routes.onboarding.route)}>
              <InfoCircleOutlined /> {t('menu.onboarding')}
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={() => openRoute(routes.faq.route)}>
              <QuestionOutlined /> {t('menu.moreInfo')}
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <a href={`mailto:${t('global.support.supportEmailWithSubject')}`}>
                <CustomerServiceOutlined /> {t('menu.support')}
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="[&_svg]:text-destructive-text!"
              onSelect={() => {
                logout();
              }}
            >
              <LogoutOutlined /> {t('menu.logout')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
export default PageTopBar;
